import { render, staticRenderFns } from "./correct-pop.vue?vue&type=template&id=5d446f8b&"
import script from "./correct-pop.vue?vue&type=script&lang=js&"
export * from "./correct-pop.vue?vue&type=script&lang=js&"
import style0 from "./correct-pop.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports